import AdminLotGroups from './AdminLotGroups'
export default AdminLotGroups
